// third-party
import { createSlice } from '@reduxjs/toolkit';
import { returnFiltersQueryString } from 'helpers/objectFunctions';

// project imports
import axios from 'utils/axios';
import { dispatch } from 'store';
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { DEFAULT_ERROR_MESSAGE } from '../constant';
import { openSnackbar } from './snackbar';
import { devConsolelog } from 'helpers/utilityFunctions';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    data: {
        utilities: {
            filters: []
        }
    },
    isLoading: true,
    filters: {},
    autoSuggestData: {
        dropdownData: []
    },
    airlineData: [],
    filterOptions: {}
};

const slice = createSlice({
    name: 'bookingList',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // setData
        setData(state, action) {
            const { count = 0, next = null, previous = null, results = {}, page = 0 } = action.payload;
            const { utilities = {}, booking_list: bookingList = [] } = results || {};
            state.data.count = count;
            state.data.next = next;
            state.data.previous = previous;
            state.data.utilities = utilities;
            state.data.bookingList = bookingList;
            state.data.currentPage = page;
        },

        setAutosuggestData(state, action) {
            devConsolelog('auto suggest data ', state, action.payload);
            const {
                code__completion: memCodeData = [],
                company_name__completion: companyNameData = [],
                email__completion: emailData = [],
                name__completion: nameData = []
            } = action.payload;

            const autosuggestData = [
                memCodeData[0]?.options,
                nameData[0]?.options,
                companyNameData[0]?.options,
                emailData[0]?.options
            ].find((arr) => arr.length);

            const autosuggestDropdownData = autosuggestData.map((data) => {
                const { _source: source = {} } = data || {};
                const { name = '', code = '', email = '', company_name: companyName = '' } = source || {};

                return { code, name, email, companyName, label: `${code} ${name} ${email} ${companyName}` };
            });

            state.autoSuggestData.dropdownData = autosuggestDropdownData;
        },

        setFilters(state, action) {
            state.filters = action.payload;
        },

        setAirlineData(state, action) {
            state.airlineData = action.payload;
        },

        setMemberDropdownData(state, action) {
            state.filterOptions.acmData = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getBookingListDataAndFilters(pageChangeUrl = '', filterType = '', newPage = 0, utilities = {}) {
    // const { filters = [] } = utilities || {};
    devConsolelog('dsidus3434', filterType);
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/bookings/?`;
        if (pageChangeUrl) {
            url = pageChangeUrl;
        }
        if (filterType) {
            const filterQueryString = returnFiltersQueryString(filterType);

            url = `${url}${filterQueryString}`;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });

            dispatch(slice.actions.setData({ ...response.data, page: filterType ? 0 : newPage }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setData({ results: { utilities, booking_list: [] }, page: filterType ? 0 : newPage }));
        }
    };
}

// getAutosuggestMemberData
export function getAutosuggestMemberData(searchedVal = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/member/suggest?code__completion=${searchedVal}&company_name__completion=${searchedVal}&name__completion=${searchedVal}&email__completion=${searchedVal}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getAutosuggestMemberData', response.data);
            dispatch(slice.actions.setAutosuggestData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getOrgAutosuggestData(searchedVal = '') {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}organization/suggest?code__completion=${searchedVal}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getOrgAutosuggestData', response.data);
            dispatch(slice.actions.setAutosuggestData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAirlineData() {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}travsys/airlines`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            devConsolelog('response getAirlineData', response.data);
            dispatch(slice.actions.setAirlineData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getMemberDropdownData() {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}users/travclan-admin`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            devConsolelog('response getMemberList', response.data);
            dispatch(slice.actions.setMemberDropdownData([...response.data]));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {} } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export const filtersData =
    (filter = '') =>
    async () => {
        dispatch(slice.actions.setFilters(filter));
    };
